import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter } from "react-router";
import isEmpty from "lodash.isempty";
import { getMerchantVoucherList } from "../../../redux/actions/voucherActions";
import activeImg from "../../../img/imgright.png";
import voidImg from "../../../img/imgwrong.png";
import { appConfig } from "../../../config";

class Print extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteLogo: "",
      deal: "",
      voucherNumber: "",
      userName: ""
    };
  }

  componentWillMount() {
    let dealID = this.props.match.params.dealID
      ? this.props.match.params.dealID
      : "";
    let postData = {
      dealID: dealID,
      page: "0"
    };
    this.props.getMerchantVoucherList(postData);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantVoucherList !== nextProps.merchantVoucherList) {
      if (nextProps.merchantVoucherList) {
        this.setState({
          voucherData: nextProps.merchantVoucherList.data,
          siteLogo: nextProps.merchantVoucherList.siteLogo,
          deal: nextProps.merchantVoucherList.dealText
        });
      }
    }
  }

  render() {
    let voucherRow;
    let voucherListData = this.state.voucherData ? this.state.voucherData : "";
    if (!isEmpty(voucherListData) && this.state.dealID !== "") {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>
            {voucher.status == "Active" ? (
              <img
                src={activeImg}
                style={{ borderColor: "grey" }}
                width="30px"
              />
            ) : voucher.status == "Void" ? (
              <img src={voidImg} style={{ borderColor: "grey" }} width="30px" />
            ) : (
              ""
            )}
          </td>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.userName} </td>
        </tr>
      ));
    }

    return (
      <div>
        <div className="row">
          <div className="col-lg-12">
            <table className="col-lg-12 text-center">
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <img
                      src={appConfig.site.siteurl + this.state.siteLogo}
                      width="100px"
                    />{" "}
                  </td>
                </tr>
                <tr>
                  <td>{this.state.deal}</td>
                </tr>
                <tr>
                  <td>Voucher List</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="clearfix" />
        <hr />
        <div className="row">
          <div className="col-lg-12">
            <table className="table">
              <tbody>{voucherRow}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  merchantVoucherList: state.voucherReducer.merchantVoucherList,
  voucherStatus: state.voucherReducer.voucherStatus
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { getMerchantVoucherList })
)(Print);



// WEBPACK FOOTER //
// ./src/app/views/merchant/voucher/Print.js